import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, distinct, every, first, map, Subject, takeUntil, tap } from 'rxjs';
import { LgvAPIService, LgvConstants, LgvUserService, NotificationService } from '../../core/core.module';
import { LgvModel } from '../../data-models/longevity.model';
import { environment as env } from '../../../environments/environment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'lus-billing-modal',
    templateUrl: './billing-modal.component.html',
    styleUrls: ['./billing-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class BillingModalComponent implements OnInit, OnDestroy {

    @Input() billingUrl: string;
    isLoading$ = new BehaviorSubject(false);
    onDestroy$ = new Subject();

    iFrameUrlParam: string;
    userInfoParam: LgvModel.Agent;

    get title(): string { return 'Billing Page Title'; }
    get safeFrameUrlParam(): SafeResourceUrl { return this.domSanitizer.bypassSecurityTrustResourceUrl(this.iFrameUrlParam); };

    constructor(
        private domSanitizer: DomSanitizer,
        public dialogRef: MatDialogRef<BillingModalComponent>,
        public MatDialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public data: any) {

        if (!!data?.iFrameUrl) {
            this.iFrameUrlParam = data.iFrameUrl;
        }

        if (!!data?.userInfo) {
            this.userInfoParam = data.userInfo;
        }

        console.log('iFrameUrl:');
        console.log(this.iFrameUrlParam);


    }

    ngOnInit(): void {
    }



    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }




    //    onSubmit() {
    //    //    if (!this.companyForm.valid) {
    //    //        return;
    //    //    }

    //    //    this.isLoading$.next(true);

    //    //    let model = this.companyForm.getRawValue();
    //    //    model.address1 = this.selectedAddressControl.value?.address + ' ' + this.unitNumberControl?.value;
    //    //    model.city = this.cityControl.value;
    //    //    model.state = this.stateControl.value;
    //    //    model.zipCode = this.zipControl.value;

    //    //    this.lgvApiSvc.SaveCompany(model).pipe(takeUntil(this.onDestroy$)).subscribe(companyResponse => {

    //    //        this.isLoading$.next(false);
    //    //        setTimeout(() => {
    //    //            this.notificationSvc.success('Company has been saved');
    //    //        }, 500)
    //    //        this.lgvApiSvc.loadCompanies();
    //    //        this.dialogRef.close({ action: false });

    //    //        if (this.isCreateMode) {
    //    //            this.router.navigate([`/admin/company`, companyResponse?.id]);
    //    //        }

    //    //    }
    //    //        , err => {
    //    //            this.isLoading$.next(false);
    //    //            this.notificationSvc.error("There was an error saving the company");
    //    //        }
    //    //    );
    //    }

    onClose() {
        this.dialogRef.close({ action: false });
    }

}
